module.exports = __webpack_public_path__ + "static/media/4ODA18.991a476f.jpg";